import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import CertificateLink from "components/CpdLocker/CertificateLink.jsx";
import { cpdPoints } from "components/CPDPoints";
import constants from "constants";
import renderSponsors from "components/Dashboard/renderSponsors";
import renderExperts from "components/Dashboard/renderExperts";
import renderPartners from "components/Dashboard/renderPartners";
import WebinarSponsorsRepresentative from "../../../WebinarSponsorsRepresentative";
import { connect } from "react-redux";
import { noImagePlaceholder } from "../../../../constants/baseConst";

const { CPD_STATUSES } = constants;

const PreviousWebinarItem = ({
  webinar: {
    webinar_title,
    start_date,
    vimeo_url,
    partnerships,
    sponsor,
    sponsors,
    joined,
    is_quiz_completed,
    cpd_status,
    experts,
    id,
  },
  webinar,
  token,
  subscriptionAction,
  currentGroup: { logo_url, title },
}) => {
  return (
    <div
      className="section_previous"
      onClick={subscriptionAction}
      key={`previous_webinars_${id}`}
    >
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        <div className="col l3 webinar_title">
          <p className="section_previous_theme"></p>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div>
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
        {/* {Boolean(webinar.sponsor_representative.length) && (
          <div className="col l2">
            <WebinarSponsorsRepresentative
              sponsors={webinar.sponsor_representative}
            />
          </div>
        )} */}
        <div className="col l2">
          <p className="section_date">
            <p>Duration</p>
            {webinar.duration || "N/A"}
          </p>
          <p className="section_time"></p>
        </div>
        <div className="col l2">
          <img
            className="group-card-image"
            src={logo_url || noImagePlaceholder}
          />
          <h6 style={{ textAlign: "center" }}>{title}</h6>
        </div>
        <div className="col l2">
          {sponsors && sponsors.length && sponsors.length > 0 ? (
            <div>
              <p>Brought to you by:</p>
              {renderSponsors(sponsor, sponsors, false)}
            </div>
          ) : null}
        </div>
        <div className="col l1">
          <p className="section_previous_points">CPD Points:</p>
          <br />
          <p>{cpdPoints(webinar)}</p>
        </div>

        <div className="col l1">
          {(joined || is_quiz_completed) &&
            cpd_status === CPD_STATUSES.granted && (
              <CertificateLink token={token} webinarId={webinar.id} />
            )}
        </div>
      </div>
      {/*<a href="javascript:void(0)" onClick={vimeo_url && subscriptionAction}></a>*/}
      {renderExperts(experts)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentGroup: state.studygroups.studygroup,
});

const mapDispatchToProps = (dispatch) => ({});

PreviousWebinarItem.propTypes = {
  webinar: PropTypes.obj,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviousWebinarItem);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Recorded/PreviousWebinarItem.js